import React, { useState } from 'react';
import BoltIcon from '@mui/icons-material/Bolt';
import { onSuccess } from '../api';
import Base from '../layouts/Base';
import classes from '../api/classes';
import SystemData from './systemData';
import { stores } from '../stores';
import { ConfirmDialog } from '../components/ConfirmDialog';
import { Toast } from '../components/Toast/Toast';
import { Button } from '../components/Button/Button';
import clsx from 'clsx';

const { Reports } = classes;

const isAdmin = () => stores.identity.isAdministrator();

onSuccess.add((resp) => resp.delayedCacheInvalidation && isAdmin() && Base.renderGlobal((closeFn) => (
	<Toast
		open
		message={({ close }) => (
			<div className="flex flex-col gap-2">
				Possible updates of ARI report-data that reflects changes you&apos;ve just done is delayed until the next daily API-import.
				<ConfirmDialog
					title="Confirm rebuilding of ARI report data"
					text="This action might affect responsiveness of the system during the following minutes, are you sure?"
				>
					<Button variant="outlined" className="block" onClick={() => { Reports.invalidateCache({ force: true }); close(); }}>Apply updates now</Button>
				</ConfirmDialog>
			</div>
		)}
		timeout={5}
		status="info"
		onClose={closeFn}
	/>
)));

class DelayedCacheInvalidation extends React.Component {
	constructor(props) {
		super(props);
		const getState = () => ({ delayed: !!SystemData.genericData.delayedInvalidations });
		Object.assign(this, {
			state: getState(),
			listener: () => this.setState(getState()),
		});
		SystemData.onGenericDataUpdated.add(this.listener, true);
	}

	componentWillUnmount() {
		SystemData.onGenericDataUpdated.remove(this.listener());
	}

	render() {
		const { delayed } = this.state;
		if (!delayed || !isAdmin()) {
			return null;
		}
		return (
			<Toast
				open
				status="warning"
				position="bottom-left"
				closeable={false}
				// eslint-disable-next-line react/no-unstable-nested-components
				message={({ close, setPaused }) => (
					<ARIUpdatesToast close={close} setPaused={setPaused} />
				)}
				icon={<BoltIcon />}
			/>
		);
	}
}

function ARIUpdatesToast({ close, setPaused }: { close: () => void, setPaused: (paused: boolean) => void }) {
	const [expanded, setExpanded] = useState(false);

	return (
		<div className="flex flex-col gap-2" onClick={() => setExpanded(true)}>
			<p className="font-bold">ARI updates pending</p>
			<div className={clsx('hidden group-hover:block', expanded && 'block!')}>
				<div className="flex flex-col gap-2 mb-3">
					<p>Updates have been done in the system that have not yet been reflected in ARI reports. Examples of updates that may affect the content of ARI reports include:</p>
					<ul className="list-disc list-inside">
						<li>Mapping of SSP-placements</li>
						<li>Changes of share % for publsher accounts / SSPs</li>
					</ul>
					<span>Press this button to ensure that ARI report data is updated. These updates are otherwise delayed until the next daily API-import.</span>
				</div>
				<div className="flex flex-row gap-2">
					<ConfirmDialog
						title="Confirm rebuilding of ARI report data"
						text="This action might affect responsiveness of the system during the following minutes, are you sure?"
						onOpen={() => setPaused(true)}
						onAny={() => setPaused(false)}
					>
						<Button size="s" onClick={() => { Reports.invalidateCache({ force: true }); close(); }}>Apply updates now</Button>
					</ConfirmDialog>
					<Button variant="outlined" size="s" onClick={close}>Dismiss</Button>
				</div>
			</div>
		</div>
	);
}

export default DelayedCacheInvalidation;
